var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    _vm.colorClasses,
    'inline-flex sm:w-32 lg:w-full max-w-32 justify-center items-center px-2.5 py-0.5 rounded-md font-medium leading-5' ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }